module.exports = __webpack_public_path__ + "edit-de91cd2bd2047e5fc9a5.png";